export default function CustomAlignmentIcon ({value}) {

  if (value === 'left') {
    return <>
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(3.000000, 6.000000)" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <path d="M0.75,0.75 L11.3277874,0.75 M0.75,6 L14.4700197,6 M0.75,11.25 L7.61000983,11.25"></path>
          </g>
        </g>
      </svg>
    </>
  }

  if (value === 'center') {
    return <>
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(3.000000, 6.000000)" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <path d="M4,0.75 L14,0.75 M0.75,6 L17.25,6 M5,11.25 L12.2172088,11.25"></path>
          </g>
        </g>
      </svg>
    </>
  }

  if (value === 'right') {
    return <>
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(4.000000, 6.000000)" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <path d="M5.29951709,0.75 L15.25,0.75 M1.24365166,6 L15.25,6 M8.24682583,11.25 L15.25,11.25"></path>
          </g>
      </g>
      </svg>
    </>
  }

  if (value === 'top') {
    return <>
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(3.000000, 3.000000)" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <path d="M0,1 L14.25,1 M0,5 L9.75,5 M0,9 L7.125,9 M10.5,11.75 L14.25,8 M14.25,8 L18,11.75 M14.25,8 L14.25,17.0555947"></path>
          </g>
        </g>
      </svg>
    </>
  }

  if (value === 'middle') {
    return <>
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(3.000000, 2.000000)" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <path d="M0,10 L9.75,10 M0,14 L5.25,14 M10.5,15.75 L14.25,12 M18,4.25 L14.25,8 M14.25,12 L18,15.75 M14.25,8 L10.5,4.25 M14.25,12 L14.25,19.9889945 M14.25,8 L14.25,0.309365595"></path>
            <path d="M0,6 L5.25,6"></path>
          </g>
      </g>
      </svg>
    </>
  }

  if (value === 'bottom') {
    return <>
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(2.000000, 4.000000)" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <path d="M1,16 L15.25,16 M1,12 L10.75,12 M1,8 L7.6875,8 M15.25,0.322477119 L15.25,10 M15.25,10 L11.5,6.25 M15.25,10 L19,6.25"></path>
          </g>
        </g>
      </svg>
    </>
  }

  return <>
    <div className="red">
      ?
    </div>
  </>

}
